// extracted by mini-css-extract-plugin
module.exports = {"first":"Chart3_first__13ZIJ","second":"Chart3_second__3KUem","third":"Chart3_third__PKSyg","four":"Chart3_four__3Bys4","five":"Chart3_five__3YxXv"};